<template>
    <Transition name="modal-fade">
        <div v-if="isVisible" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div
                        v-if="isVisible"
                        class="cf-dialog cf-dialog--xl"
                        aria-modal="true"
                        role="dialog"
                        aria-labelledby="modal-title"
                >

                    <!-- Header -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-edit-box-line"></i></span>
                            <div>
                                <h4 id="modal-title" class="cf-dialog-title">Personnalisation des libellés</h4>
                                <p class="cf-modal-head__sub">{{ typeConfig.description }}</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer">
                            <i class="ri-close-line"></i>
                        </button>
                    </div>

                    <!-- Tabs Navigation -->
                    <div class="cf-dialog-tabs">
                        <nav class="flex" aria-label="Tabs">
                            <button
                                    v-for="tab in tabs"
                                    :key="tab.id"
                                    @click="activeTab = tab.id"
                                    type="button"
                                    :class="['fa2-tab', { 'fa2-tab--active': activeTab === tab.id }]"
                                    :aria-selected="activeTab === tab.id"
                                    :aria-controls="`tab-${tab.id}`"
                            >
                                <component :is="tab.icon" class="w-4 h-4" />
                                {{ tab.label }}
                            </button>
                        </nav>
                    </div>

                    <!-- Body -->
                    <div class="cf-dialog-body">
                        <!-- Tab 1: Information libre -->
                        <div
                                v-if="activeTab === 'information-libre'"
                                id="tab-information-libre"
                                role="tabpanel"
                                aria-labelledby="tab-information-libre"
                        >
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <template v-for="(field, index) in informationLibreFields" :key="index">
                                    <div class="space-y-2">
                                        <label :for="field.id" class="fa2-label">
                                            {{ field.label }}
                                            <span v-if="field.helpText" class="cl-help">{{ field.helpText }}</span>
                                        </label>
                                        <input
                                                :id="field.id"
                                                v-model="libelleachat.informationlibre[field.key]"
                                                type="text"
                                                :placeholder="`Saisir ${field.label.toLowerCase()}...`"
                                                class="fa2-inp"
                                                :class="{ 'fa2-inp--error': field.hasError }"
                                        >
                                        <p v-if="field.hasError" class="fa2-err">{{ field.errorMessage }}</p>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <!-- Tab 2: Adresse d'expédition -->
                        <div
                                v-if="activeTab === 'adresse-expedition'"
                                id="tab-adresse-expedition"
                                role="tabpanel"
                                aria-labelledby="tab-adresse-expedition"
                        >
                            <div class="space-y-6">
                                <div class="grid grid-cols-1 gap-6">
                                    <template v-for="field in adressePrincipaleFields" :key="field.id">
                                        <div class="space-y-2">
                                            <label :for="field.id" class="fa2-label">{{ field.label }}</label>
                                            <input
                                                    :id="field.id"
                                                    v-model="libelleachat.adresseexpedition[field.key]"
                                                    type="text"
                                                    :placeholder="`Saisir ${field.label.toLowerCase()}...`"
                                                    class="fa2-inp"
                                            >
                                        </div>
                                    </template>
                                </div>

                                <div class="cf-section-sep">
                                    <h3 class="cf-section-title">Adresses supplémentaires</h3>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                                        <template v-for="field in adresseSecondaireFields" :key="field.id">
                                            <div class="space-y-2">
                                                <label :for="field.id" class="fa2-label">{{ field.label }}</label>
                                                <input
                                                        :id="field.id"
                                                        v-model="libelleachat.adresseexpedition[field.key]"
                                                        type="text"
                                                        :placeholder="`Saisir ${field.label.toLowerCase()}...`"
                                                        class="fa2-inp"
                                                >
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="cf-dialog-foot">
                        <span class="cl-footnote">
                            <i class="ri-information-line"></i>
                            Les modifications sont sauvegardées automatiquement
                        </span>
                        <button @click="resetToDefaults" type="button" class="ti-btn ti-btn-warning-full">
                            <i class="ri-refresh-line align-middle"></i> Réinitialiser
                        </button>
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                        <button @click="save" type="button" class="ti-btn ti-btn-primary-full">
                            <i class="ri-check-line align-middle"></i> Enregistrer
                        </button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "CustomLabelsModal",

        data() {
            return {
                isVisible: false,
                activeTab: 'information-libre',
                libelleachat: {
                    informationlibre: {
                        informationlibre: '',
                        informationlibre1: '',
                        informationlibre2: '',
                        informationlibre3: '',
                        informationlibre4: '',
                        informationlibre5: '',
                        informationlibre6: '',
                        informationlibre7: '',
                        informationlibre8: '',
                        informationlibre9: '',
                        informationlibre10: '',
                        informationlibre11: '',
                        informationlibre12: ''
                    },
                    adresseexpedition: {
                        informationlibre: '',
                        informationlibre1: '',
                        informationlibre2: '',
                        informationlibre3: '',
                        informationlibre4: '',
                        informationlibre5: ''
                    }
                },
                typeupdate: '',
                hasUnsavedChanges: false
            };
        },

        computed: {
            tabs() {
                return [
                    {
                        id: 'information-libre',
                        label: 'Informations libres',
                        icon: 'TabInfoIcon'
                    },
                    {
                        id: 'adresse-expedition',
                        label: 'Adresses d\'expédition',
                        icon: 'TabAddressIcon'
                    }
                ];
            },

            typeConfig() {
                const configs = {
                    achat: {
                        description: 'Personnalisation des libellés pour les achats',
                        fieldsCount: 12
                    },
                    frsclt: {
                        description: 'Personnalisation des libellés pour les fournisseurs/clients',
                        fieldsCount: 6
                    }
                };
                return configs[this.typeupdate] || configs.achat;
            },

            informationLibreFields() {
                const fields = [];
                const maxFields = this.typeupdate === 'achat' ? 12 : 6;

                for (let i = 1; i <= maxFields; i++) {
                    const suffix = i === 1 ? '' : i;
                    const field = {
                        id: `info-libre-${i}`,
                        key: `informationlibre${suffix}`,
                        label: i === 1 ? 'Information libre' : `Information libre ${i}`,
                        hasError: false,
                        errorMessage: ''
                    };

                    // Add help text for specific fields
                    if (this.typeupdate === 'frsclt' && i === 4) {
                        field.helpText = 'Récupère par défaut les permis des chauffeurs';
                    }

                    fields.push(field);
                }

                return fields;
            },

            adressePrincipaleFields() {
                return [
                    { id: 'adresse-principale', key: 'informationlibre', label: 'Adresse principale' },
                    { id: 'adresse-secondaire', key: 'informationlibre1', label: 'Adresse secondaire' }
                ];
            },

            adresseSecondaireFields() {
                return [
                    { id: 'adresse-2', key: 'informationlibre2', label: 'Adresse 2' },
                    { id: 'adresse-3', key: 'informationlibre3', label: 'Adresse 3' },
                    { id: 'adresse-4', key: 'informationlibre4', label: 'Adresse 4' },
                    { id: 'adresse-5', key: 'informationlibre5', label: 'Adresse 5' }
                ];
            },

            TabInfoIcon() {
                return {
                    template: `
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        `
                };
            },

            TabAddressIcon() {
                return {
                    template: `
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
        `
                };
            }
        },

        watch: {
            libelleachat: {
                handler() {
                    this.hasUnsavedChanges = true;
                },
                deep: true
            }
        },

        methods: {
            show(libelleachat, typeupdate) {
                this.libelleachat = {
                    informationlibre: { ...this.libelleachat.informationlibre, ...libelleachat?.informationlibre },
                    adresseexpedition: { ...this.libelleachat.adresseexpedition, ...libelleachat?.adresseexpedition }
                };

                this.typeupdate = typeupdate;
                this.isVisible = true;
                this.hasUnsavedChanges = false;

                // Lock body scroll
                document.body.style.overflow = 'hidden';
            },

            close() {
                if (this.hasUnsavedChanges) {
                    if (!confirm('Vous avez des modifications non sauvegardées. Voulez-vous vraiment quitter ?')) {
                        return;
                    }
                }
                this.isVisible = false;
                document.body.style.overflow = '';
            },

            async save() {
                try {
                    // Validation
                    if (!this.validateFields()) {
                        return;
                    }

                    // Save based on type
                    if (this.typeupdate === 'achat') {
                        JwtService.unsetCUSTOMLIBELLE();
                        JwtService.setCUSTOMLIBELLE(JSON.stringify(this.libelleachat));
                    } else if (this.typeupdate === 'frsclt') {
                        JwtService.unsetCUSTOMLIBELLEFRSCLT();
                        JwtService.setCUSTOMLIBELLEFRSCLT(JSON.stringify(this.libelleachat));
                    }

                    // Emit success
                    this.$emit('saved', {
                        type: 'update',
                        typeupdate: this.typeupdate,
                        value: this.libelleachat
                    });

                    // Show success message
                    this.showNotification('success', 'Libellés sauvegardés avec succès');

                    this.hasUnsavedChanges = false;
                    this.isVisible = false;
                    document.body.style.overflow = '';

                } catch (error) {
                    console.error('Erreur lors de la sauvegarde:', error);
                    this.showNotification('error', 'Erreur lors de la sauvegarde');
                }
            },

            validateFields() {
                let isValid = true;

                // Validate required fields
                this.informationLibreFields.forEach(field => {
                    field.hasError = false;

                    if (this.typeupdate === 'frsclt' && field.key === 'informationlibre3') {
                        if (!this.libelleachat.informationlibre[field.key]?.trim()) {
                            field.hasError = true;
                            field.errorMessage = 'Ce champ est requis pour les permis de chauffeurs';
                            isValid = false;
                        }
                    }
                });

                return isValid;
            },

            resetToDefaults() {
                if (confirm('Voulez-vous vraiment réinitialiser tous les libellés ?')) {
                    const defaults = {
                        informationlibre: {},
                        adresseexpedition: {}
                    };

                    // Reset all fields to empty
                    Object.keys(this.libelleachat.informationlibre).forEach(key => {
                        defaults.informationlibre[key] = '';
                    });

                    Object.keys(this.libelleachat.adresseexpedition).forEach(key => {
                        defaults.adresseexpedition[key] = '';
                    });

                    this.libelleachat = defaults;
                    this.showNotification('info', 'Tous les libellés ont été réinitialisés');
                }
            },

            showNotification(type, message) {
                // You can integrate with a notification system here
                console.log(`${type}: ${message}`);

                // For now, use browser alert
                alert(message);
            }
        },

        beforeUnmount() {
            document.body.style.overflow = '';
        }
    };
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--xl { max-width:1050px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-tabs { padding:0 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; flex-wrap:wrap; }

.fa2-tab { position:relative; display:flex; align-items:center; gap:6px; padding:10px 16px; font-size:0.82rem; font-weight:600; border:none; border-bottom:2px solid transparent; background:none; cursor:pointer; transition:all .15s; white-space:nowrap; color:var(--cf-muted); }
.fa2-tab:hover { color:var(--cf-ink); background:rgb(var(--primary)/0.06); }
.fa2-tab--active { color:rgb(var(--primary))!important; border-bottom-color:rgb(var(--primary)); background:rgb(var(--primary)/0.08); }

.fa2-label { font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em; font-weight:600; color:var(--cf-muted); display:flex; align-items:center; gap:4px; flex-wrap:wrap; }
.fa2-inp { width:100%; height:40px; padding:0 12px; border-radius:0.25rem; border:1px solid rgb(var(--input-border,203 213 225)); background:#fff; color:var(--cf-ink); font-size:0.82rem; outline:none; transition:border-color .2s, box-shadow .2s; }
.fa2-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary)/0.10); }
.fa2-inp--error { border-color:rgb(var(--danger)); background:#fef2f2; }
.fa2-err { font-size:0.72rem; color:rgb(var(--danger)); margin-top:2px; }

.cl-help { font-size:0.7rem; font-weight:400; text-transform:none; letter-spacing:0; color:var(--cf-faint); }
.cl-footnote { margin-right:auto; display:inline-flex; align-items:center; gap:0.4rem; font-size:0.78rem; color:var(--cf-muted); }
.cf-section-sep { border-top:1px solid var(--cf-border); padding-top:1.25rem; }
.cf-section-title { margin:0; font-size:0.85rem; font-weight:700; color:var(--cf-ink-strong); }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--xl { max-width:100%; } }
</style>
